"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auditable = void 0;
class Auditable {
    constructor(auditableFields) {
        this.createDate = auditableFields.createDate;
        this.updateDate = auditableFields.updateDate;
        this.createdBy = auditableFields.createdBy;
        this.updatedBy = auditableFields.updatedBy;
    }
}
exports.Auditable = Auditable;
//# sourceMappingURL=Auditable.js.map